var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"back",attrs:{"to":_vm.backUrl},on:{"click":function($event){return _vm.go()}}},[_c('back-icon'),_vm._v("\n  BACK\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }